<template>
    <div class="heading">
        <slot></slot>
    </div>
</template>

<style scoped>
.heading {
    font-size: 1rem;
}

@media (max-width: 600px) {
    .heading {
        margin-left: 10px;
        margin-right: 5px;
    }
}

@media (max-width: 500px) {
    .heading {
        margin-left: 6px;
        margin-right: 3px;
    }
}
</style>